if (!customElements.get('product-card')) {
  class ProductCart extends HTMLElement {
    constructor() {
      super();
      backgroundCheck('[data-adaptive-text]');
      this.colorSwatches = this.querySelectorAll('.product-card-item__colors-content li');

      if (this.colorSwatches.length){
        this.colorSwatches.forEach((elm) => {
          const swatch = elm.querySelector('.color-swatch');
          if (swatch && !swatch.style.backgroundColor && !swatch.style.backgroundImage) {
            elm.classList.add('hide');
          }
        });
      }
    }
  }

  customElements.define('product-card', ProductCart);
}
